<section class="main">
    <div class="mb-3 d-flex justify-content-between align-items-center supmain">
        <h3>Manage units</h3>
        <div class="icon">
            <!-- <img (mouseenter)="multiUnits = !multiUnits" (click)="checkBoxStatus = !checkBoxStatus"
                (mouseleave)="multiUnits = !multiUnits" src="assets/images/mangeunit/1.png">
            <img class="ms-3" src="assets/images/mangeunit/4.png">
            <img class="ms-3" src="assets/images/mangeunit/2.png">
            <img class="ms-3" src="assets/images/mangeunit/3.png">
            <img class="ms-3" src="assets/images/mangeunit/5.png"> -->
            <button class="btn ms-3" (click)="add_unit()">Add new unit</button>
        </div>
    </div>
    <div *ngIf="multiUnits" class="mangeUnits">
        <p>Select more than one unit to take that action</p>
    </div>
    <div class="supmain mb-4 filter d-flex justify-content-between align-items-center">
        <div class="form-group" class="searchInput">
            <input type="search" [(ngModel)]="unitName" (input)="searchUnit()" class="form-control"
                placeholder="Search unit">
        </div>
        <div class="dropdown mb-0 ">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                data-bs-toggle="dropdown" aria-expanded="false">
                {{typeName}}
                <img src="assets/images/mangeunit/arrow.png">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li *ngFor="let item of typesArr"><a class="dropdown-item"
                        (click)="searchByType(item.name)">{{item.name}}</a></li>
            </ul>
        </div>
    </div>

    <!-- table units -->

    <section class="tableUnit table-responsive">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">Unit name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Other info</th>
                    <th scope="col" class="text-end">Quick actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of units_arr ; let i = index">
                    <td class=" d-flex align-items-center">
                        <input (change)="inputcheckBox($event,item,i)" id="{{item.id}}" *ngIf="checkBoxStatus"
                            class="me-1" type="checkbox">
                        <label *ngIf="! checkBoxStatus" style="cursor: pointer"
                            (click)="unitDetails(item.name)">{{item.name}}</label>
                        <label for="{{item.id}}" *ngIf="checkBoxStatus" style="cursor: pointer">{{item.name}}</label>

                    </td>
                    <td>
                        <span>{{item.type}}</span>
                    </td>
                    <td></td>
                    <td class="text-end">
                        <img *ngIf="!checkBoxStatus" style="cursor: pointer" src="assets/images/mangeunit/6.png">
                        <img *ngIf="!checkBoxStatus" style="cursor: pointer" class="ms-3"
                            src="assets/images/mangeunit/7.png">
                    </td>
                </tr>
            </tbody>
        </table>
        <h3 *ngIf="units_arr == null">No Data Found</h3>
    </section>

    <div *ngIf="unit_blocked_btn_status && checkBoxStatus" class="text-end">
        <button (click)="blockUnitGates()" class="btn blockUnit mt-2">Block Units</button>

    </div>

   <div *ngIf="unitName == ''">
        <mat-paginator (page)="handlePageEvent($event)"  [pageIndex]="pageIndex" [length]="5003" [pageSize]="page_size" 
    [pageSizeOptions]="[10, 25, 100 , 150 , 200]" aria-label="Select page">
    </mat-paginator>
   </div> 
   

</section>